import {
  SET_LOADING_DATA,
  SET_LOADING_SEND,
  GET_BY_ID_REQUEST,
  GET_BY_ID_SUCCESS,
  SAVE_REQUEST,
  SAVE_SUCCESS,
  UPDATE_IMAGE_TENANT,
  UPDATE_IMAGE_SUBSIDIARY,
  UPDATE_PRICE_TABLE,
  SET_PAGE,
  SET_ROWS_PER_PAGE,
  SET_ROWS_COUNT,
  SET_ROWS_ORIENTATION,
  SET_ORDER,
  SET_ORDERBY,
  GET_ALL_REQUEST,
  GET_ALL_SUCCESS,
  SET_LOADING_LIST,
  TEST_TENANT_CONNECTION,
  TEST_TENANT_CONNECTION_LOADING
} from './tenant-constants';

export const setPage = (page: Number) => {
  return {
    type: SET_PAGE,
    page
  };
};

export const setRowsPerPage = (rowsPerPage: Number) => {
  return {
    type: SET_ROWS_PER_PAGE,
    rowsPerPage
  };
};

export const setRowsCount = (rowsCount: Number) => {
  return {
    type: SET_ROWS_COUNT,
    rowsCount
  };
};

export const setRowsOrientation = (rowsOrientation: string) => {
  return {
    type: SET_ROWS_ORIENTATION,
    rowsOrientation
  };
};

export const setOrder = (order: String) => {
  return {
    type: SET_ORDER,
    order
  };
};

export const setOrderBy = (orderBy: (string | boolean)[]) => {
  return {
    type: SET_ORDERBY,
    orderBy
  };
};

export const getAllRequest = (filters?: any) => {
  return {
    type: GET_ALL_REQUEST,
    filters
  };
};

export const getAllSuccess = (payload: any) => {
  return {
    type: GET_ALL_SUCCESS,
    payload
  };
};

export const setLoadingData = (loading: Boolean) => {
  return {
    type: SET_LOADING_DATA,
    loading
  };
};

export const setLoadingList = (loading: Boolean) => {
  return {
    type: SET_LOADING_LIST,
    loading
  };
};

export const setLoadingSend = (loading: Boolean) => {
  return {
    type: SET_LOADING_SEND,
    loading
  };
};

export const getTenantRequest = () => {
  return {
    type: GET_BY_ID_REQUEST
  };
};

export const getTenantSuccess = (payload: any) => {
  return {
    type: GET_BY_ID_SUCCESS,
    payload
  };
};

export const saveRequest = (id: any, payload) => {
  return {
    type: SAVE_REQUEST,
    id,
    payload
  };
};

export const saveSuccess = () => {
  return {
    type: SAVE_SUCCESS
  };
};

export const updateImageTenant = (file: any) => {
  return {
    type: UPDATE_IMAGE_TENANT,
    file
  };
};

export const updateImageSubsidiary = (subsidiaryId: any, file: any) => {
  return {
    type: UPDATE_IMAGE_SUBSIDIARY,
    subsidiaryId,
    file
  };
};

export const updatePriceTableCode = payload => {
  return {
    type: UPDATE_PRICE_TABLE,
    payload
  };
};

export const getTestConnectionTenantRequest = () => {
  return {
    type: TEST_TENANT_CONNECTION
  };
};

export const getTestConnectionTenantLoading = (payload: boolean) => {
  return {
    type: TEST_TENANT_CONNECTION_LOADING,
    payload
  };
};
